import { InjectionToken } from '@angular/core';

export class PlcHttpConfig {
	public serverUrl!: string;
}

export const PlcHttpConfigService = new InjectionToken<PlcHttpConfig>(
	'PlcHttpConfig',
);
